export class StatusData {
  Data: Status[];
  Count: number;
}

export class Status {
  constructor (init?: Partial<Status>) {
    if (init) {
      Object.assign(this, init);
    }
  }
  Id?: number;
  SUid?: string;
  Name1?: string;
  Name2?: string;
  IsNeutral?: boolean;
  ViewPoint?: number;
  CategoryCO?: number;
  CategoryCT?: number;
  CategorySC?: number;
  IsChecked?: boolean = false;
  IsLocked?: boolean;
}


export enum CategoryEnum {
  Open   = 1,
  Closed = 2
}
